import { BaseApiService } from '@/Services/base-api-service'
import { isAxiosError } from '@/Services/HttpClient/axios-plugin'
import { IUser } from '../Models/IUser';
import { ITypedValidationResult } from '../Models/IValidationResult';

class userService extends BaseApiService {
    public constructor() {
        super('User/');
    }

    private static config = {
        headers: {
            'AuthorizationNeeded': true,
            // Other headers can be added here if needed
        }
    };

    public async getByAuth0Id(auth0Id: string): Promise<IUser> {
        return this.httpClient.get<IUser>(`GetByAuth0Id?auth0Id=${auth0Id}`, userService.config).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async saveUser(user: IUser) {
        console.log('Saving User');
        return this.httpClient.post<ITypedValidationResult<IUser>>('SaveUser', user, userService.config).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }
}

export const UserService: userService = new userService();